export function mapEpguStatus(status: string): string {
  switch (status) {
    case 'SENT':
      return 'Уведомление направлено в ЕПГУ, подтверждение не получено';
    case 'RECEIVED':
      return 'Уведомление размещено в ЛК контролируемого лица ЕПГУ';
    default:
      return '';
  }
}
